import React, { useState, useRef } from 'react';
import '../App.css';
function BackButton({theme, onBack}) {
    const dayBackBtn = require('../static/images/assetComponents/back/backDay.webp');
    const dayBackBtnH = require('../static/images/assetComponents/back/backDayh.webp');
    const nightBackBtn = require('../static/images/assetComponents/back/backNight.webp');
    const nightBackBtnH = require('../static/images/assetComponents/back/backNighth.webp');

    const backIcon = theme === 'light' ? 
        { normal: dayBackBtn, hover: dayBackBtnH } : 
        { normal: nightBackBtn, hover: nightBackBtnH };
    const [isHovering, setIsHovering] = React.useState(false);
    return (
        <button 
            className="backBtn" 
            onClick={onBack}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
        >
            <img 
                src={isHovering ? backIcon.hover : backIcon.normal} 
                alt="Back button"
                className='backBtnImage' 
            />
        </button>
    );
}
export default BackButton;